import { HttpErrorResponse } from '@angular/common/http';

export interface RestError {
    readonly code: string;
    readonly parameters?: object;
    readonly message?: string;
    readonly errors?: readonly RestError[];
}

export enum restErrorEnum {
    badRequest = 'badRequest',
    notFound = 'notFound',
    internal = 'internal',
    network = 'network',
    unexpected = 'unexpected',
    conflict = 'conflict',
    notAllow = 'notAllow',
    unauthorized = 'unauthorized',
}

export function processRestError(response: unknown): restErrorEnum | string {
    if (response instanceof HttpErrorResponse) {
        if (response.status === 400) {
            if (response.error == null) {
                return restErrorEnum.badRequest;
            }

            const error = response.error.error as RestError;
            if (error === undefined) {
                return restErrorEnum.badRequest;
            }
            return error.code || restErrorEnum.badRequest;
        } else if (response.status === 401) {
            return restErrorEnum.unauthorized;
        } else if (response.status === 404) {
            return restErrorEnum.notFound;
        } else if (response.status === 405) {
            return restErrorEnum.notAllow;
        } else if (response.status === 409) {
            const error = response.error?.error as RestError;
            return error.code || restErrorEnum.conflict;
        } else if (response.status === 500) {
            return restErrorEnum.internal;
        } else if (response.status === 0) {
            return restErrorEnum.network;
        } else {
            return restErrorEnum.unexpected;
        }
    } else {
        return restErrorEnum.unexpected;
    }
}
